<template>
  <div class="home">
    <b-overlay :show="isLoading" rounded="sm">
      <meet
        v-if="isJoinMeeting && appid && token"
        :channel="channel"
        :appid="appid"
        :userAccount="userAccount"
        :token="token"
        :preMute="config.mute"
        :preCameraOff="config.cameraOff"
        @leave-meeting="handleLeaveMeeting"
      />
      <main-page
        v-else
        @join-meeting="handleJoinMeeting"
        :isJoining="isLoading"
        :errorMsg="errorMsg"
        :channel="channel"
        :appid="appid"
        :token="token"
      />
    </b-overlay>
  </div>
</template>

<script>
import { BOverlay } from "bootstrap-vue";
import axios from "axios";
// import gapi from 'google-client-api';
import Meet from "@/components/Meet.vue";
import MainPage from "@/components/Main.vue";

var urlSearchParams = new URLSearchParams(window.location.search);
var params = Object.fromEntries(urlSearchParams.entries());
console.log("params", params);

let isTest = false;

if (params && params.domain == "test") {
  isTest = true;
}

import {
  RtcTokenBuilder,
  RtmTokenBuilder,
  RtcRole,
  RtmRole,
} from "agora-token";
function randomKey() {
  return new Date().getTime() + Math.floor(Math.random() * 10000).toString();
}
// import random from "lodash.random";
// https://agora-token-server-l2yj.onrender.com/rtc/MyChannel/1/uid/1/?expiry=300
export default {
  name: "Home",
  components: {
    BOverlay,
    Meet,
    MainPage,
  },
  data() {
    return {
      isLoading: true,
      isJoinMeeting: false,
      config: null,
      //appid: "0b699957872f431c90a66ca52035af85",
      appid: null,
      // channel:"tcpRagmyat@2030",
      channel: null,
      certificate: null,
      cameraOff: null,
      mute: null,
      token: null,
      orderData: {},
      // uid:randomKey(),
      uid: null,
      errorMsg: null,
      userAccount: null,
      order_uuid: null,
      expireTimeInSeconds: 0,

      //  0091f2a356c44c209ea590336022ea8e
      // token:"007eJxTYHhYpJKktejm8vrLd1xt3SfET8if+mzTw3PClkXHjR6vfZquwGCQZGZpaWlqbmFulGZibJhsaZBoZpacaGpkYGyamGZh6jvdPbUhkJGh0lCEgREKQXxmhpLkAgYGAHrDHwg=",
      //    token:"0068eddf6b4278b4e9d86ac9ddd8d7eef6fIAAUUurkf3pHjMPum9DEvEuGByHx4kWRJX3mtlRYNIQitjzp3DcAAAAAEAC2CAMvMesLYQEAAQAx6wth",
      // appid: localStorage.getItem("appid"),
      // channel: sessionStorage.getItem("channel"),
      // token:
      //   localStorage.getItem("token") === "null"
      //     ? null
      //     : localStorage.getItem("token") === null
      //     ? undefined
      //     : localStorage.getItem("token")
    };
  },
  watch: {
    // appid: {
    //   immediate: true,
    //   handler(newV) {
    //     if (!newV || newV === "null" || newV === undefined) {
    //       const appid = window.prompt("Input your appid:");
    //       if (appid) {
    //         localStorage.setItem("appid", appid);
    //         this.appid = appid;
    //       } else {
    //         window.location.reload();
    //       }
    //     }
    //   }
    // },
    // channel: {
    //   immediate: true,
    //   handler(newV) {
    //     if (!newV || newV === "null" || newV === undefined) {
    //       const channel = window.prompt("Input your room channel:");
    //       if (channel) {
    //         sessionStorage.setItem("channel", channel);
    //         this.channel = channel;
    //       } else {
    //         window.location.reload();
    //       }
    //     }
    //   }
    // },
    // token: {
    //   immediate: true,
    //   handler(newV) {
    //     if (!newV && newV !== null) {
    //       const token = window.prompt("Input your token:");
    //       if (token) {
    //         localStorage.setItem("token", token);
    //         this.token = token === "null" ? null : token === null ? undefined : token;
    //       } else {
    //         window.location.reload();
    //       }
    //     }
    //   }
    // }
  },
  mounted() {
    //  007eJxTYOB5be3rIP/8u0/VCaa4E5tO3kp7dYrL9vHPwD3c2qvev5NSYDBIMrO0tDQ1tzA3SjMxNky2NEg0M0tONDUyMDZNTLMwbQgISm0IZGSYnh7KwAiFID4/Q0lyQVBiem5lYokDULEBAwMA7agi6Q==
    // this.$vsLoading({
    //     container:'body',
    //    scale: 3
    //   })
    const order_token = this.$route.params.order_uuid;
    this.order_uuid = order_token;
    this.fetchOrderData(order_token);
    // if(usethisToken && usethisToken==true){
    //  this.token=token_tem_gen;
    // }else{
    //  this.generateRtcToken();
    // }

    //  this.$vs.loading.close(container)
    // $('.vs-loading').remove();
    //this.initializeGoogleSignIn();
    // this.token=this.generateToken(this.channel);
  },
  methods: {
    initializeGoogleSignIn() {
      gapi.load("auth2", () => {
        gapi.auth2
          .init({
            client_id:
              "473129772948-v865ish79l81ed9j7kkgkhahovrkkmis.apps.googleusercontent.com",
          })
          .then(() => {
            // تحقق من حالة تسجيل الدخول عند تحميل المكون
            this.updateSignInStatus(
              gapi.auth2.getAuthInstance().isSignedIn.get(),
            );
          });
      });
    },
    updateSignInStatus(isSignedIn) {
      if (isSignedIn) {
        // إذا كان المستخدم قد سجل الدخول، قم بالحصول على معلومات المستخدم
        const googleUser = gapi.auth2.getAuthInstance().currentUser.get();
        this.userAccount = googleUser.getBasicProfile().getName();
      } else {
        // إذا لم يكن المستخدم قد سجل الدخول، افتح نافذة تسجيل الدخول
        gapi.auth2
          .getAuthInstance()
          .signIn()
          .then(() => {
            // بعد تسجيل الدخول، حدث معلومات المستخدم
            this.updateSignInStatus(true);
          });
      }
    },
    signInWithGoogle() {
      const isSignedIn = gapi.auth2.getAuthInstance().isSignedIn.get();
      this.updateSignInStatus(isSignedIn);
    },

    initializeGoogleSignInOld() {
      gapi.load("auth2", () => {
        gapi.auth2
          .init({
            client_id:
              "473129772948-v865ish79l81ed9j7kkgkhahovrkkmis.apps.googleusercontent.com",
          })
          .then(() => {
            const auth2Instance = gapi.auth2.getAuthInstance();
            auth2Instance.attachClickHandler(
              document.getElementById("google-signin-button"),
              {},
              (googleUser) => {
                const profile = googleUser.getBasicProfile();
                this.userAccount = profile.getName();
              },
              (error) => {
                console.error(error);
              },
            );
          });
      });
    },
    fetchOrderData(order_token, token = undefined) {
      var params = Object.fromEntries(urlSearchParams.entries());
      let apiurl = window.api_url;
      if (params && params.domain == "test") {
        apiurl = "https://test.thqil.com/api";
      }

      this.errorMsg = null;
      this.isLoading = true;
      const self = this;

      const promise = axios
        .get(`${apiurl}/meeting/${order_token}`, {
          token: token,
          params: params,
        })
        .then((res) => {
          this.errorMsg = null;
          var data = res.data.result;
          self.appid = data.appid;
          self.channel = data.channel;
          self.certificate = data.certificate;
          self.userAccount = data.userAccount;
          self.expireTimeInSeconds = data.expireTimeInSeconds;
          self.orderData = data;
          this.generateRtcToken();
        })
        .catch((error) => {
          this.isLoading = false;
          let res = error.response;
          let msg = null;
          if (res.data && res.data.msg) {
            msg = res.data.msg;
          } else if (res.msg) {
            msg = res.msg;
          }

          this.$message.error(msg);
          this.errorMsg = msg;
          console.log(error);
        });
    },
    async ensureMicrophonePermission() {
      try {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          this.$message.error("المتصفح لا يدعم الوصول إلى الميكروفون");

          return false;
        }

        console.log("[MIC] Checking microphone permission...");

        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });

        const audioTrack = stream.getAudioTracks()[0];

        if (!audioTrack) {
          stream.getTracks().forEach((track) => track.stop());

          this.$message.error("لم يتم العثور على ميكروفون");

          return false;
        }

        console.log("[MIC] Permission OK", {
          label: audioTrack.label,
          enabled: audioTrack.enabled,
          muted: audioTrack.muted,
          readyState: audioTrack.readyState,
        });

        /*
         * هذا stream فقط لفحص الصلاحية.
         * Agora سينشئ Audio Track الخاص به بعد ذلك.
         */
        stream.getTracks().forEach((track) => track.stop());

        return true;
      } catch (error) {
        console.error("[MIC] Permission failed:", error);

        if (
          error.name === "NotAllowedError" ||
          error.name === "PermissionDeniedError"
        ) {
          this.$message.error(
            "صلاحية الميكروفون مرفوضة. يرجى السماح للمتصفح باستخدام الميكروفون ثم المحاولة مرة أخرى.",
          );
        } else if (error.name === "NotFoundError") {
          this.$message.error("لم يتم العثور على ميكروفون في الجهاز.");
        } else if (error.name === "NotReadableError") {
          this.$message.error(
            "تعذر تشغيل الميكروفون. قد يكون مستخدمًا بواسطة تطبيق آخر.",
          );
        } else {
          this.$message.error("تعذر الوصول إلى الميكروفون.");
        }

        return false;
      }
    },
    async handleJoinMeeting(config) {
      console.log("[Meeting] Join requested", config);

      /*
       * إذا كان المستخدم سيدخل والمايك ON
       * نفحص الصلاحية قبل إنشاء Meet.vue
       */
      if (!config.mute) {
        const microphoneAllowed = await this.ensureMicrophonePermission();

        if (!microphoneAllowed) {
          console.error(
            "[Meeting] Join cancelled because microphone permission failed",
          );

          return;
        }
      }

      /*
       * لا ننشئ Meet إلا بعد نجاح فحص الميكروفون
       */
      this.config = {
        mute: config.mute,
        cameraOff: config.cameraOff,
      };

      console.log("[Meeting] Microphone ready - creating Meet component");

      this.isJoinMeeting = true;
    },
    handleLeaveMeeting() {
      let apiurl = window.api_url;
      if (isTest) {
        apiurl = "https://test.thqil.com/api";
      }
      const promise = axios
        .post(`${apiurl}/meeting/${this.order_uuid}/close`, {
          ...this.orderData,
          token: this.token,
        })
        .then(function(res) {
          // self.token=res.data;
        })
        .catch(function(err) {
          console.log(err);
        });
      this.isJoinMeeting = false;
    },
    generateRtcToken() {
      // Rtc Examples
      // console.log('randomKey',randomKey());
      const appId = this.appid;
      const appCertificate = this.certificate;
      const channelName = this.channel;
      //const uid=this.uid;
      const uid = 0;
      //const userAccount =this.uuid;
      const account = "2882341273";
      //var userAccount =this.userAccount;
      const userAccount = "";
      const role = RtcRole.PUBLISHER;
      var params = Object.fromEntries(urlSearchParams.entries());
      //  const userAccount =params['type'];
      const expirationTimeInSeconds = this.expireTimeInSeconds
        ? this.expireTimeInSeconds
        : 3600;

      const currentTimestamp = Math.floor(Date.now() / 1000);

      const privilegeExpiredTs = currentTimestamp + expirationTimeInSeconds;

      // IMPORTANT! Build token with either the uid or with the user account. Comment out the option you do not want to use below.

      // Build token with uid
      //const token = RtmTokenBuilder.buildToken(appID, appCertificate, randomKey(), RtmRole, privilegeExpiredTs);

      const tokenA = RtcTokenBuilder.buildTokenWithUid(
        appId,
        appCertificate,
        channelName,
        uid,
        role,
        privilegeExpiredTs,
      );
      // console.log("Token With Integer Number Uid: " + tokenA);

      // // Build token with user account
      //const tokenB = RtcTokenBuilder.buildTokenWithUserAccount(appId, appCertificate, channelName, userAccount, role, privilegeExpiredTs);
      this.token = tokenA;
      this.isLoading = false;
      //console.log("Token With UserAccount: " + tokenB);
    },
  },
};
</script>
